// TODO: Should be moved to button component when we have one single component

window.board_trackResourceDownloadEvent = function () {
  if (!window.boardflow) {
    return;
  }
  window.boardflow.track("resource", "download");
};

document.addEventListener("DOMContentLoaded", function () {
  // Get all buttons with the data attribute data-track-resource-download
  const buttons = document.querySelectorAll(
    '[data-track-resource-download="true"]'
  );
  // Loop through each button and add the click event listener
  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      window.board_trackResourceDownloadEvent();
    });
  });
});
